import { initializeClientSubApplication } from "./load-application";
import ProductHotspotFrontend from "../components/ProductHotspotFrontend";

initializeClientSubApplication(
  "product-hotspot-frontend-",
  ProductHotspotFrontend
);
